import i18next from 'i18next';

const errorMessage = '오류가 발생하였습니다. 잠시 후 다시 이용해주세요.';

export const getDefaultErrorMessage = () =>
    i18next.t(errorMessage) || errorMessage;
